module.exports = __webpack_public_path__ + "img/Banner2.d534b44.jpg";